module.exports = __webpack_public_path__ + "img/icon_letter.feae6f0e.svg";